import { withBrowserTextareaHeight } from '@/src/general/utils/withBrowserTextareaHeight'

import { CommentTextarea as CommentTextareaNative } from './CommentTextarea.shared'

export const CommentTextarea = withBrowserTextareaHeight(CommentTextareaNative)
